export let SearchFolderOption_Title = "A$_3Ie";
export let optionSearch_searchFolders = "LX62ic";
export default {SearchFolderOption_Title,optionSearch_searchFolders};